export const isSelectedRowDisabled = (key, disabledKeys) => {
  return disabledKeys.some(k => k === key);
};